import { Injectable, Injector } from "@angular/core";
import { DatasourceService } from "./repositories/datasource/datasource.service";
import { TestGroupsService } from "./repositories/test-groups/test-groups.service";
import { AppsService } from "./repositories/apps/apps.service";
import { UserService } from "./repositories/user/user.service";
import { VendorsService } from "./repositories/vendors/vendors.service";
import { SegmentsService } from "./repositories/segments/segments.service";
import { AttributesService } from "./repositories/attributes/attributes.service";
import { JourneysService } from "./repositories/journeys/journeys.service";
import { AnalyticsService } from "./repositories/analytics/analytics.service";
import { UserManagementService } from "./repositories/user-management/user-management.service";
import { JourneySocketService } from "./repositories/journeys/journey-socket.service";
import { ChargebeeService } from "./repositories/chargebee/chargebee.service";
import { MiscService } from "./repositories/misc/misc.service";

@Injectable({
  providedIn: "root"
})
export class DatacontextService {
  private _datasourceService: DatasourceService;
  private _testGroups: TestGroupsService;
  private _apps: AppsService;
  private _user: UserService;
  private _vendors: VendorsService;

  private _segments: SegmentsService;
  private _attributes: AttributesService;
  private _journeys: JourneysService;
  private _analytics: AnalyticsService;
  private _userManagement: UserManagementService;

  private _journeySocket: JourneySocketService;
  private _ChargebeeService: ChargebeeService;
  private _MiscService: MiscService;

  constructor(private injector: Injector) {}

  public get datasource(): DatasourceService {
    if (!this._datasourceService) {
      this._datasourceService = this.injector.get(DatasourceService);
    }
    return this._datasourceService;
  }

  public get testGroups(): TestGroupsService {
    if (!this._testGroups) {
      this._testGroups = this.injector.get(TestGroupsService);
    }
    return this._testGroups;
  }

  public get apps(): AppsService {
    if (!this._apps) {
      this._apps = this.injector.get(AppsService);
    }
    return this._apps;
  }

  public get user(): UserService {
    if (!this._user) {
      this._user = this.injector.get(UserService);
    }
    return this._user;
  }

  public get vendors(): VendorsService {
    if (!this._vendors) {
      this._vendors = this.injector.get(VendorsService);
    }
    return this._vendors;
  }

  public get segments(): SegmentsService {
    if (!this._segments) {
      this._segments = this.injector.get(SegmentsService);
    }
    return this._segments;
  }

  public get attributes(): AttributesService {
    if (!this._attributes) {
      this._attributes = this.injector.get(AttributesService);
    }
    return this._attributes;
  }

  public get journeys(): JourneysService {
    if (!this._journeys) {
      this._journeys = this.injector.get(JourneysService);
    }
    return this._journeys;
  }

  public get analytics(): AnalyticsService {
    if (!this._analytics) {
      this._analytics = this.injector.get(AnalyticsService);
    }
    return this._analytics;
  }

  public get userManagement(): UserManagementService {
    if (!this._userManagement) {
      this._userManagement = this.injector.get(UserManagementService);
    }
    return this._userManagement;
  }

  public get journeySocket(): JourneySocketService {
    if (!this._journeySocket) {
      this._journeySocket = this.injector.get(JourneySocketService);
    }
    return this._journeySocket;
  }

  public get chargebee(): ChargebeeService {
    if (!this._ChargebeeService) {
      this._ChargebeeService = this.injector.get(ChargebeeService);
    }
    return this._ChargebeeService;
  }

  public get misc(): MiscService {
    if (!this._MiscService) {
      this._MiscService = this.injector.get(MiscService);
    }
    return this._MiscService;
  }
}
